
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";

interface AnalysisSearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const AnalysisSearchBar = ({ searchQuery, setSearchQuery }: AnalysisSearchBarProps) => {
  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Search className="h-4 w-4 text-gray-400" />
      </div>
      <Input
        type="text"
        placeholder="Search criteria..."
        className="pl-10 pr-10"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      {searchQuery && (
        <button
          onClick={() => setSearchQuery("")}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <X className="h-4 w-4 text-gray-400 hover:text-gray-600" />
        </button>
      )}
    </div>
  );
};